

export const baseUrl = 'http://bms.dkinnovation.fr:85/'
const version = 'api/v1/'

export const defaultHeaders = {Accept: 'application/json', 'Content-Type': 'application/json'}


export const signup = baseUrl + version + 'entrance/signup'
export const login = baseUrl /*+ version+*/ + 'entrance/login'

export const addDevice = baseUrl + version + 'user/device'

export const getUser = userId =>  baseUrl + version +`user/${userId}`
export const changePassword = () =>  baseUrl + version +'entrance/update-password-and-login'
export const sendNewPasswordLink = () =>  baseUrl + version +'entrance/send-password-recovery-email'
export const getAllUsers = () =>  baseUrl + version +'users'
export const removeUser = () =>  baseUrl + version +'remove/user'

export const addBatteryToUser = () => baseUrl + version + 'user/battery/sn'
export const removeBattery = () => baseUrl + version + 'remove/battery'
export const getAllBatteries = () =>  baseUrl + version +'batteries'
export const getBatteryById = batteryId =>  baseUrl + version +`battery/id/${batteryId}`
export const getMyBatteries = userId =>  baseUrl + version +`batteries/user/${userId}`
export const removeUserFromBattery = (user_id, battery_id) => baseUrl + version + 'remove/user/battery'
export const getStates = (batteryId, page, size) =>  baseUrl + version +`battery/id/${batteryId}/states/${page}/${size}`
export const getMyBattery = (batteryId) =>  baseUrl + version +`adminBattery/id/${batteryId}`
export const getCellStates = (batteryId, page, size, all) =>  baseUrl + version +`cell/${batteryId}/states/${page}/${size}/${all?1:0}`
